var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('building-link',{attrs:{"activity":_vm.activity}}),_vm._v("のグループを「"+_vm._s(_vm.activity.group.name)+"」へ変更しました。")],1)}
var staticRenderFns = []

export { render, staticRenderFns }